"use client";

import { useState } from "react";
import { type ContentSection_Fields } from "~/__generated__/graphql";
import CustomImage from "./CustomImage";
import VideoPopup from "./VideoPopup";
import { cn } from "~/utils/cn";

export default function IframeWrapper({
  video,
  icon = "play_arrow",
  ignoreCookies = false,
}: {
  video: NonNullable<ContentSection_Fields["video"]>;
  icon?: string;
  ignoreCookies?: boolean;
}) {
  const [videoPopupOpen, setVideoPopupOpen] = useState(false);

  const hasVideo =
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    (video.source?.[0] === "File" && video?.file) ||
    (video.source?.[0] === "Url" && video?.url);

  return (
    <>
      <div
        onClick={() => setVideoPopupOpen(true)}
        className={cn(
          "relative flex min-h-[20rem] justify-center",
          hasVideo && "hover:cursor-pointer",
        )}
      >
        <CustomImage
          data={video.preview}
          className="h-auto min-h-full w-fit object-contain sm:h-0"
          sizes="(min-width: 1980px) 474px, (min-width: 1300px) calc(3.94vw + 397px), (min-width: 1260px) calc(-180vw + 2742px), (min-width: 1040px) calc(33vw + 65px), (min-width: 780px) calc(49.17vw - 28px), (min-width: 640px) 474px, calc(100vw - 48px)"
        />
        {hasVideo && icon && (
          <div className="material-icons-round absolute left-1/2 top-1/2 z-1 -translate-x-1/2 -translate-y-1/2 rounded bg-blue p-3 text-white">
            {icon}
          </div>
        )}
      </div>
      {hasVideo && video.source?.[0] === "Url" && video.url && (
        <VideoPopup
          isOpen={videoPopupOpen}
          ignoreCookies={ignoreCookies}
          callback={() => {
            setVideoPopupOpen(false);
          }}
          videoSourceUrl={video.url}
          isPrismicVideo={false}
          title="Video"
        />
      )}
    </>
  );
}
